import styled, { css } from 'styled-components';
import colors from 'Styles/colors';

export const SelectWsSection = styled.div`
  background-color: ${({ theme }) => theme.backgrounds.scheduleWrapper};
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.1);
  padding: 25px 21px;
  border-radius: 4px;
`;
SelectWsSection.displayName = 'SelectWsSection';

export const WrapperField = styled.div`
  
`;
WrapperField.displayName = 'WrapperField';

export const TextInput = styled.div`
  font-size: 17.5px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.sideModaTitle};
  margin-bottom: 14px;
  ${({ $mandatory }) => $mandatory && css`
    &::after {
      content: ' *';
      margin-left: 2px;
      color: ${colors.redPink};
    }
  `}
`;
TextInput.displayName = 'TextInput';

export const Label = styled.p`
  font-size: 12.5px;
  color: ${colors.greyBlue};
  padding-bottom: 21px;
`;
Label.displayName = 'Label';
